import { onBeforeUnmount } from 'vue';

export function useAbortableRequest() {
  let controller: AbortController | null = null;

  function getSignal() {
    controller?.abort();
    controller = new AbortController();
    return controller.signal;
  }

  onBeforeUnmount(() => controller?.abort());

  return { getSignal };
}
